
import accordionComponent from "./components/accordion/accordionComponent";
import accordionType from "./components/accordion/accordionType"

import tabComponent from './components/tab/tabComponent'
import tabType from './components/tab/tabType'

import LoveMapInput from './components/inputs/LoveMapInput'
import LoveMapSelect from './components/inputs/LoveMapSelect'
import LoveMapToggle from './components/inputs/LoveMapToggle'

import TxImageCropper from './components/image-cropper/TxImageCropper'
import LoveMapButton from './components/other/LoveMapButton'
import LoveMapDescription from './components/other/LoveMapDescription'
import LoveMapSmallText from './components/other/LoveMapSmallText'

import TxCkeEditor from './components/cke-editor/TxCkeEditor'
import TxSettingsUi from './components/TxSettingsUi'

export default {
    install(Vue, option) {

        Vue.component('LoveMapInput', LoveMapInput)
        Vue.component('LoveMapSelect', LoveMapSelect);
        Vue.component('LoveMapToggle', LoveMapToggle);

        Vue.component('accordionComponent', accordionComponent);
        Vue.component('accordionType', accordionType);

        Vue.component('tabComponent', tabComponent);
        Vue.component('tabType', tabType);

        Vue.component('TxImageCropper', TxImageCropper);

        Vue.component('LoveMapButton', LoveMapButton);
        Vue.component('LoveMapDescription', LoveMapDescription);
        Vue.component('LoveMapSmallText', LoveMapSmallText);

        Vue.component('TxCkeEditor', TxCkeEditor);

        Vue.component('TxSettingsUi', TxSettingsUi);

    }
};